import React, { useEffect, useState } from 'react'
import './index.sass'

export default function Chip({text, isActive, onclick}) {
    const [activeState, setActiveState] = useState(isActive);

    useEffect(() => {
        setActiveState(isActive);
    }, [isActive])
    
    return (
        <div onClick={onclick} className={activeState ? 'profile-chip-active' : 'profile-chip'}>
            {text}
        </div>
    )
}
